<template>
<div class="address-details-component">
  <header class="address-details-component__header">
    <h3 class="address-details-component__header-title">
      Редактирование адреса{{ address && address.name ? ` «${address.name}»` : '' }}
    </h3>
    <div class="flex-grow invisible"></div>
    <button class="address-details-component__close-link" @click="$router.back()">
      Закрыть
    </button>
  </header>
  <ValidationObserver @submit.prevent="onSubmit"
                      tag="form"
                      ref="validationObserver"
                      class="address-details-component__body"
  >
    <CustomInput label="Название"
                 v-model="infoForm.name"
                 class="address-details-component__address-name"
    />

    <dadata-address-resolver v-if="addressesResolver === 'dadata'"
                             :collapsible="false"
                             :scrollable="false"
                             :address="address"
                             :editing="true"
                             v-model="form"
    />
    <plain-address-resolver v-else-if="addressesResolver === 'plain'"
                            :collapsible="false"
                            :address="address"
                            :editing="true"
                            v-model="form"
    />

    <CustomField label="Комментарий">
      <textarea v-model="infoForm.notes" class="form-control" />
    </CustomField>
    <div class="address-details-component__buttons-row">
      <div>
        <button :disabled="loading" type="submit" class="btn btn-primary btn-rounded">
          {{ address === null ? 'Создать' : 'Сохранить' }}
        </button>
        <button @click="$router.back()" type="button" class="btn btn-primary-outline btn-rounded ml-2">
          Отмена
        </button>
      </div>
    </div>
  </ValidationObserver>
</div>
</template>

<script>
import axios from '@/zenky'
import { ValidationObserver } from '@/helpers/veeValidateCustomized';
import { mapGetters } from 'vuex'

export default {
  components: {
    DadataAddressResolver: () => import('@/components/addresses/dadata/DadataAddressResolver'),
    PlainAddressResolver: () => import('@/components/addresses/plain/PlainAddressResolver'),
    CustomInput: () => import('@/components/inputs/CustomInput'),
    CustomField: () => import('@/components/inputs/CustomField'),
    ValidationObserver,
  },

  props: {
    address: {
      required: false,
      type: Object,
      default: () => null,
    },
  },

  created() {
    if (this.address) {
      this.infoForm.name = this.address.name
      this.infoForm.notes = this.address.notes
    }
  },

  computed: {
    ...mapGetters({
      addressesResolver: 'store/addressesResolver',
    }),

    payloadForm() {
      return {
        delivery_address: {
          ...this.form,
          name: this.infoForm.name,
          notes: this.infoForm.notes,
        },
      }
    },
  },

  methods: {
    async onSubmit() {
      if (await this.$refs.validationObserver.validate() === false) {
        return;
      }

      const p = this.address === null ? this.create() : this.edit();
      this.loading = true;

      try {
        await p;
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
        await this.$store.dispatch('savedAddresses/load', this.$store.state.auth.token);
      }
    },

    async create() {
      const { id } = (await axios.post('/profile/addresses', this.payloadForm)).data.data;

      await this.$router.replace({ name: 'addresses.edit', params: { id } });
    },

    async edit() {
      await axios.put(`/profile/addresses/${this.address.id}`, this.payloadForm);
    },
  },

  watch: {
    address: {
      immediate: true,
      handler() {
        this.form = null
        this.infoForm.name = ''
        this.infoForm.notes = ''
      },
    },
  },

  data() {
    return {
      form: undefined,

      infoForm: {
        name: '',
        notes: '',
      },

      loading: false,
    }
  }
}
</script>

<style lang="less">
@import '../../../pages/profile/common.less';

@r: address-details-component;
.@{r}__row {
  @apply m-2;
  display: grid;
  @longest-label: 9ch; // TODO locales.
  grid-template-columns: minmax(@longest-label, 1fr) 4fr;
  column-gap: theme('margin.3');
}
.address-details-component {
  @apply flex flex-col; // So the content does not overflow the card.
  &__header:extend(.profile__card-header) {}
  &__header-title:extend(.profile__card-header-title) {}
  &__close-link:extend(.profile__card-header-button) {}
  &__body {
    @apply p-3 overflow-auto;
  }
  .custom-field:extend(.address-details-component__row) {
    column-gap: theme('margin.3');
    align-items: center;
    .form-control-label {
      @apply text-sm p-0;
      justify-self: end;
    }
    .custom-field__error-text {
      grid-column-start: 2;
    }
  }
  &__buttons-row:extend(.address-details-component__row) {
    > div {
      grid-column-start: 2;
    }
  }
}
</style>
